// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_lbQ","cls2":"FilterPanel-cls2_zt1 FilterPanel-cls1_lbQ"};